module.exports = __webpack_public_path__ + "img/six.be00327e.png";